module.exports = __webpack_public_path__ + "img/file_edit_rename.f9b21c47.png";